import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';



declare var google;
@Component({
  selector: 'page-poimap',
  templateUrl: 'poimap.html',
})
export class PoimapPage {
  @ViewChild('mapFull') mapElement: ElementRef;
  Data: any
  Type: string = ''
  Map: any
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN) {
    this.Data = navParams.get('data')
    this.Type = navParams.get('type')
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad PoimapPage');
    this.initMap()
  }

  initMap() {
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
      // disableDefaultUI: true,
      // keyboardShortcuts: false,
      // streetViewControl: false,
      // scrollWhell: false,
      // clickableIcons: false,
      // draggable: true
    }
    this.Map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.gn._Post('/api/gn/insertgoogleuse', { cid: this.gn.crypt(this.gn.user.ClientId), uid: this.gn.crypt(this.gn.user.UserId), path: this.gn.crypt('poi map') }, function () {
    })


    if (this.Type == 'poi') {
      if (this.Data.pois == "") {
        var _lat = parseFloat(this.Data.lat)
        var _lng = parseFloat(this.Data.long)
        var myLatLng = { lat: _lat, lng: _lng };

        var markerIcon = {
          url: 'assets/imgs/newpin-red.png',
          scaledSize: new google.maps.Size(38, 43),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(13, 43),
          labelOrigin: new google.maps.Point(13, 13)
        };

        /*done*/var marker = new google.maps.Marker({
          position: myLatLng,
          map: this.Map,
          title: this.Data.name,
          icon: markerIcon,
          label: {
            //text: lbl,
            color: "#000",
            fontSize: "14px",
            fontWeight: "bold",
          }
        });
        this.Map.setCenter(myLatLng)
      } else {
        var _pp = []
        var poiArr = this.Data.pois.split(',')
        for (var i = 0; i < poiArr.length; i++) {
          _pp.push({ lat: parseFloat(poiArr[i].split(' ')[0]), lng: parseFloat(poiArr[i].split(' ')[1]) })
        }

        var _poly = new google.maps.Polygon({
          paths: _pp,
          //strokeColor: this.Data.scolor,
          strokeColor: this.Data.color,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.Data.color,
          fillOpacity: 0.35
        });

        _poly.setMap(this.Map);

        var bounds = new google.maps.LatLngBounds();
        var j;

        for (j = 0; j < _pp.length; j++) {
          bounds.extend(_pp[j]);
        }

        this.Map.setCenter(bounds.getCenter())
        this.Map.fitBounds(bounds);
        this.Map.setZoom(parseInt(this.Map.getZoom()) - 1);
      }
    }
    if (this.Type == 'group') {
      var bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < this.Data.pois.length; i++) {
        if (this.Data.pois[i].pois == "") {
          var _lat = parseFloat(this.Data.pois[i].lat)
          var _lng = parseFloat(this.Data.pois[i].long)
          var myLatLng = { lat: _lat, lng: _lng };

          var markerIcon = {
            url: 'assets/imgs/newpin-red.png',
            scaledSize: new google.maps.Size(38, 43),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(13, 43),
            labelOrigin: new google.maps.Point(13, 13)
          };

          /*done*/var marker = new google.maps.Marker({
            position: myLatLng,
            map: this.Map,
            title: this.Data.pois[i].name,
            icon: markerIcon,
            label: {
              //text: lbl,
              color: "#000",
              fontSize: "14px",
              fontWeight: "bold",
            }
          });
          bounds.extend(myLatLng);
        } else {
          var _pp = []
          var poiArr = this.Data.pois[i].pois.split(',')
          for (var c = 0; c < poiArr.length; c++) {
            _pp.push({ lat: parseFloat(poiArr[c].split(' ')[0]), lng: parseFloat(poiArr[c].split(' ')[1]) })
          }

          var _poly = new google.maps.Polygon({
            paths: _pp,
            //strokeColor: this.Data.scolor,
            strokeColor: this.Data.pois[i].scolor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.Data.pois[i].color,
            fillOpacity: 0.35
          });

          _poly.setMap(this.Map);

          // var bounds = new google.maps.LatLngBounds();
          var j;

          for (j = 0; j < _pp.length; j++) {
            bounds.extend(_pp[j]);
          }
        }
      }
      this.Map.fitBounds(bounds);

    }

  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/poisettings/poimap.ts